/**
 * Tema claro/escuro.
 *
 * Três estados, não dois: `sistema` (o padrão), `light` e `dark`. Sem o
 * estado "sistema" não há como voltar atrás depois de escolher à mão, e o app
 * fica preso no claro num celular que troca sozinho ao anoitecer.
 *
 * O atributo `data-theme` só aparece no HTML quando a escolha é explícita —
 * é o que permite à media query de `tokens.css` valer no estado `sistema` e
 * perder para a escolha do usuário nos outros dois.
 *
 * A aplicação inicial NÃO acontece aqui: ela está inline no `index.html`,
 * antes da primeira pintura. Este módulo cuida das trocas depois disso.
 */
import { esquecer, guardar, ler } from './armazenamento.js';

const CHAVE = 'tema';
export const TEMAS = ['sistema', 'light', 'dark'];

export function temaEscolhido() {
  const t = ler(CHAVE);
  return TEMAS.includes(t) ? t : 'sistema';
}

/** O que está efetivamente na tela agora, resolvendo `sistema`. */
export function temaEfetivo() {
  const escolhido = temaEscolhido();
  if (escolhido !== 'sistema') return escolhido;
  if (typeof window === 'undefined' || !window.matchMedia) return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function aplicarTema(tema) {
  const alvo = TEMAS.includes(tema) ? tema : 'sistema';
  if (alvo === 'sistema') {
    esquecer(CHAVE);
    document.documentElement.removeAttribute('data-theme');
  } else {
    guardar(CHAVE, alvo);
    document.documentElement.setAttribute('data-theme', alvo);
  }
  return alvo;
}

/** Ciclo do botão: sistema → claro → escuro → sistema. */
export function proximoTema(atual) {
  const i = TEMAS.indexOf(atual);
  return TEMAS[(i + 1) % TEMAS.length];
}
